import React from "react";

class ErrorBoundaryWithStack extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hasError: false,
			error: null,
			errorInfo: null,
		};
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		this.setState({
			error: error,
			errorInfo: errorInfo,
		});
		console.error("Caught error:", error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div
					style={{
						border: "1px solid #ff4d4f",
						padding: "16px",
						borderRadius: "4px",
						background: "#fff2f0",
					}}
				>
					<h3 style={{ color: "#cf1322", margin: "0 0 8px 0" }}>
						怎么会是呢？
					</h3>
					<h3
						style={{
							color: "#cf1322",
							margin: "0 0 8px 0",
							lineHeight: 1.6,
						}}
					>
						如果该页面反复出现，你可以把下面的内容发到留言板或者
						<a
							href="mailto:mail@vtb.cat"
							style={{
								color: "#cf1322",
								fontWeight: 600,
								textDecoration: "none",
								backgroundColor: "#ffd8d6",
								padding: "2px 6px",
								margin: "0 4px",
								borderRadius: "4px",
								border: "1px solid #ffa39e",
								display: "inline-block",
								transition: "all 0.2s ease",
							}}
							onMouseEnter={(e) => {
								e.currentTarget.style.backgroundColor =
									"#ffccc7";
								e.currentTarget.style.textDecoration =
									"underline";
							}}
							onMouseLeave={(e) => {
								e.currentTarget.style.backgroundColor =
									"#ffd8d6";
								e.currentTarget.style.textDecoration = "none";
							}}
						>
							mail@vtb.cat
						</a>
					</h3>
					<p style={{ margin: "0 0 8px 0" }}>
						{this.state.error && this.state.error.toString()}
					</p>

					<details
						style={{
							whiteSpace: "pre-wrap",
							fontSize: "12px",
							color: "#555",
						}}
						open
					>
						<summary
							style={{ cursor: "pointer", marginBottom: "8px" }}
						>
							查看详细堆栈
						</summary>
						<strong>JS 堆栈:</strong>
						<pre>{this.state.error?.stack}</pre>
						<strong>组件层级堆栈:</strong>
						<pre>{this.state.errorInfo?.componentStack}</pre>
					</details>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundaryWithStack;
